import { EventsHub } from 'wootils/esm/shared';
/**
 * An _"custom"_ implementation of {@link EventsHub} for the app to handle events without all the
 * hassle of AngularJS scopes and events propagation.
 * @extends {EventsHub}
 * @ngesdoc service
 * @ngname appEvents
 * @ngmodule common
 */
class AppEvents extends EventsHub {}

export default AppEvents;
